"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FEDERAL_RULES = void 0;
const saaThresholds_1 = require("encamp-shared/dist/constants/saaThresholds");
exports.FEDERAL_RULES = [
    {
        id: "FED_CENTRAL_LQG",
        scope: "FEDERAL",
        areaType: "CENTRAL",
        generatorStatus: "LQG",
        limit: { kind: "TIME", days: 90 },
        citation: "40 CFR 262.17(a)",
    },
    {
        id: "FED_CENTRAL_SQG",
        scope: "FEDERAL",
        areaType: "CENTRAL",
        generatorStatus: "SQG",
        limit: { kind: "TIME", days: 180 },
        citation: "40 CFR 262.16(b)",
        // The 200-mile exception (below) supersedes this default when it applies.
        condition: (ctx) => !ctx.sqgOver200Miles,
    },
    {
        id: "FED_CENTRAL_SQG_200MI",
        scope: "FEDERAL",
        areaType: "CENTRAL",
        generatorStatus: "SQG",
        limit: { kind: "TIME", days: 270 },
        citation: "40 CFR 262.16(d)",
        condition: (ctx) => ctx.sqgOver200Miles,
    },
    // VSQGs have no federal central accumulation-area clock (40 CFR 262.14) —
    // intentionally no rule here for (VSQG, CENTRAL).
    {
        id: "FED_SATELLITE",
        scope: "FEDERAL",
        areaType: "SATELLITE",
        generatorStatus: "ANY",
        limit: {
            kind: "VOLUME",
            nonAcuteGal: saaThresholds_1.SAA_NON_ACUTE_VOLUME_LIMIT_GAL,
            acuteGal: saaThresholds_1.SAA_ACUTE_VOLUME_LIMIT_GAL,
            acuteKg: saaThresholds_1.SAA_ACUTE_MASS_LIMIT_KG,
            moveWindowDays: saaThresholds_1.SATELLITE_MOVE_WINDOW_DAYS,
        },
        citation: "40 CFR 262.15",
        // Excludes VSQGs, structurally: 262.15 is written as a conditional
        // exemption from the central-accumulation standards in 262.16 (SQG) and
        // 262.17 (LQG), so a satellite area is relief from clocks a VSQG never
        // had. 262.14 governs VSQGs instead and never cross-references 262.15.
        // Their binding federal constraint is the facility-wide 1,000 kg on-site
        // cap, which the facility-cap rollup owns rather than this per-area rule.
        // Three independent readings concur; human SME sign-off is still
        // outstanding.
        //
        // An unknown (null) status deliberately still matches — the conservative
        // default until a status resolves.
        //
        // Two later layers can put a VSQG back under these caps, and neither is
        // expressible here yet: some states impose accumulation-area constraints
        // that federal law waives (state overlays), and a VSQG that exceeds its
        // monthly or on-site limits takes on SQG/LQG standards for that period
        // (episodic generation) — which a year-scoped generator status cannot
        // represent.
        condition: (ctx) => ctx.generatorStatus !== "VSQG",
    },
];
//# sourceMappingURL=federal.js.map